// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"174":"todos4","229":"todos47","525":"todos50","727":"todos52"}[chunkId] || chunkId) + "." + {"174":"970c575b","229":"f1750779","317":"c1d75bf5","525":"fff8ee47","727":"c48f9b4e"}[chunkId] + ".chunk.js";
};